module.exports = __webpack_public_path__ + "img/plus.efe20b7d.svg";